export default "__VITE_ASSET__TI2wDbXw__"